import { useTranslation } from 'next-i18next'
import { FC, useMemo } from 'react'
import { batch } from 'react-redux'

import {
  pressReleaseSetIsEventFilter,
  pressReleaseSetSelected,
  pressReleaseSetSkip,
  pressReleaseSetTags,
  pressReleaseSetTitle,
} from '@/reducers/press-release'
import { useAppDispatch, useAppSelector } from '@/utils/hooks'

const SearchState: FC<{ total: number }> = ({ total }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const pressReleaseTitle = useAppSelector((state) => state.pressRelease.title)
  const pressReleaseTag = useAppSelector((state) => state.pressRelease.tags)
  const handleResetFilter = () => {
    batch(() => {
      dispatch(pressReleaseSetTitle(''))
      dispatch(pressReleaseSetTags([]))
      dispatch(pressReleaseSetIsEventFilter(true))
      dispatch(pressReleaseSetSkip(0))
      dispatch(pressReleaseSetSelected(0))
    })
  }

  const search = useMemo(() => {
    const title = `"${pressReleaseTitle}"`
    const tags = `"${pressReleaseTag.join(' , ')}"`

    if (pressReleaseTitle.length && pressReleaseTag.length) {
      return [title, tags].join(' , ')
    }
    if (!pressReleaseTitle.length && pressReleaseTag.length) {
      return tags
    }
    if (pressReleaseTitle.length && !pressReleaseTag.length) {
      return title
    }
    return ''
  }, [pressReleaseTitle, pressReleaseTag])

  if (total) {
    return (
      <div className='gap-6'>
        <div className='flex items-center justify-between gap-8 md:gap-0'>
          <p
            className='description break-words text-xs leading-normal tracking-[-0.176px] lg:text-base'
            dangerouslySetInnerHTML={{
              __html: String(
                t('press:result', {
                  total: total,
                  search: search,
                })
              ),
            }}
          />

          <button
            className='rounded-[100px] bg-red px-4 py-2 lg:px-6 lg:py-3'
            onClick={handleResetFilter}
          >
            <span className='text-[13px] font-bold text-white lg:text-base'>Reset</span>
          </button>
        </div>
      </div>
    )
  }
  return null
}

export default SearchState
